import React from 'react';
import PropType from 'prop-types';
import Select from 'react-select';
import axios from 'axios';
import settings from '../../settings.json';

const options = settings.singleCellRegions.map(region => ({ label: region[0], value: region[1] }));

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

class VolcanoPlot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comparison1: [],
      comparison2: [],
      fdrMax: 0.05,
      deMode: 'both',
      lfcMin: 1,
      sortBy: 'P',
      geneNumber: 10,
    };
  }

  handleSubmit = () => {
    const { match } = this.props;
    // grab all values from the form state.
    const comparison1 = this.state.comparison1.map(entry => entry.value);
    const comparison2 = this.state.comparison2.map(entry => entry.value);
    // clear out the form for future searches?
    // validation here??
    const payload = {
      type: 'volcanoPlot',
      category: 'single-cell',
      comparison1,
      comparison2,
      sort_by: this.state.sortBy,
      de_mode: this.state.deMode,
      topgenes: this.state.geneNumber,
      fdr_cutoff: this.state.fdrMax,
      lfc_cutoff: this.state.lfcMin,
    };
    // submit values to the backend storage and retrieve the uuid
    axios.post(`${apiProto}://${apiHost}/search`, payload).then((response) => {
      // redirect to the results page which will load in the image and parameters.
      const redirect = `${match.path}/${response.data}`;
      this.props.history.push(redirect);
    });
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md">
            <div className="form-group">
              <label htmlFor="comparison1">Comparison 1</label>
              <Select
                isMulti
                name="comparison1"
                id="comparison1"
                value={this.state.comparison1}
                onChange={value => this.setState({ comparison1: value })}
                options={options}
              />
            </div>
          </div>
          <div className="col-md">
            <div className="form-group">
              <label htmlFor="comparison2">Comparison 2</label>
              <Select
                isMulti
                name="comparison2"
                id="comparison2"
                value={this.state.comparison2}
                onChange={value => this.setState({ comparison2: value })}
                options={options}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md">
            <div className="form-group">
              <label htmlFor="sortBy">Sort</label>
              <select className="form-control" id="sortBy" name="sortBy" value={this.state.sortBy} onChange={e => this.setState({ sortBy: e.target.value })}>
                <option value="P">P-Value</option>
                <option value="logFC">log2 fold change</option>
                <option value="t">Moderated t-statistic</option>
                <option value="AveExpr">Average expression</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="fdrMax">FDR Max</label>
              <input className="form-control" type="number" name="fdrMax" id="fdrMax" value={this.state.fdrMax} onChange={e => this.setState({ fdrMax: e.target.value })} />
            </div>
          </div>
          <div className="col-md">
            <div className="form-group">
              <label htmlFor="lfcMin">log2 Fold Change Minimum</label>
              <input className="form-control" type="number" name="lfcMin" id="lfcMin" value={this.state.lfcMin} onChange={e => this.setState({ lfcMin: e.target.value })} />
            </div>
            <div className="form-group">
              <label htmlFor="geneNumber">Top Number of Genes to Plot</label>
              <input className="form-control" type="number" name="geneNumber" id="geneNumber" value={this.state.geneNumber} onChange={e => this.setState({ geneNumber: e.target.value })} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="deMode">Mode</label>
              <select className="form-control" id="deMode" name="deMode" value={this.state.deMode} onChange={e => this.setState({ deMode: e.target.value })}>
                <option value="both">Both</option>
                <option value="enrichment">Enrichment</option>
                <option value="depletion">Depletion</option>
              </select>
            </div>
          </div>
        </div>
        <button className="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
      </div>
    );
  }
}

VolcanoPlot.propTypes = {
  match: PropType.object.isRequired,
  history: PropType.object.isRequired,
};

export default VolcanoPlot;



// WEBPACK FOOTER //
// ./src/components/SingleCell/VolcanoPlot.jsx